var m = require('mithril');
var prop = require('mithril/stream');
var dragscroll = require('../libs/dragscroll');
var equipmentClassToDisplayName = require('../libs/equipmentClassToDisplayName');
var loaders = require('../layout/components/loaders');
var edit = require('../layout/components/edit');
var modal = require('../layout/components/modal');
var auth = require('../auth/models/session');
var modelDetail = require('../components/modelDetail');
var modelActions = require('../network/components/modelActions');
var paginationWithSearch = require('../data/components/paginationWithSearch');
var rowActionDropdown = require('../components/rowActionDropdown');
var Model = require('../libs/Model');
var BacnetDeviceModel = Object.assign(require('../../../../models/bacnet/bacnetDevice'), Model);
var bacnetObjectModel = Object.assign(require('../../../../models/bacnet/bacnetObject'), Model);
var bacnetEnums = require('../../../../lib/bacnetEnums');
const { get } = require('lodash');
var modalForm = require('../layout/components/modalForm');
var bacnetPollGroup = modalForm(require('./models/pollGroup'));
var pointTd = require('../data/components/pointTd');
var button = require('../components/button');
var networkTreeTransferModal = require('../network/treeTransferModal');
var tableColumns = require('../network/components/tableColumns');
var bacnetPresentation = require('./deviceDiscoveryPresentation');
var pageTitle = require('../layout/pageTitle');
var pageRequestState = require('../layout/components/pageRequestState');

var STATUSES = ['ok', 'unknown', 'warning', 'error'];
// Match the row order: Name, Object ID, Object Type, Description, Value
var bacnetObjectFields = ['name', 'objectId', 'objectType', 'description', 'value']
var page = {};

function actionDropdown(items) {
  return m(rowActionDropdown, {
    position: 'fixed',
    align: 'left',
    buttonStyle: {
      minWidth: '1.6rem',
      paddingTop: '0.05rem',
      paddingBottom: '0.12rem',
      paddingLeft: '0.18rem',
      paddingRight: '0.18rem',
      lineHeight: '1'
    },
    items: items
  });
}

function objectRowActions(ctrl, children) {
  return [
    {
      label: 'Edit ' + ctrl.BacnetObjectModel.name,
      icon: 'ion-ios-compose',
      onclick: function () { ctrl.BacnetObjectModel.editDialogue(children); }
    },
    {
      label: 'Delete ' + ctrl.BacnetObjectModel.name,
      icon: 'ion-ios-trash',
      class: 'red',
      onclick: function () { ctrl.BacnetObjectModel.deleteDialogue(children); }
    }
  ];
}

function renderObjectNameCell(ctrl, children, url) {
  return m('div.flex.items-center.justify-between', [
    m(m.route.Link, { href: url }, children.name),
    m('div.ml3.flex-none', [
      actionDropdown(objectRowActions(ctrl, children))
    ])
  ]);
}

function groupRowActions(ctrl, group) {
  return [
    {
      label: 'View Properties',
      icon: 'ion-eye',
      onclick: function () { openGroupPropertiesModal(ctrl, group); }
    },
    {
      label: 'Edit',
      icon: 'ion-ios-compose',
      onclick: function () { bacnetPollGroup.editDialogue(group); }
    },
    {
      label: 'Delete',
      icon: 'ion-ios-trash',
      class: 'red',
      onclick: function () { bacnetPollGroup.deleteDialogue(group); }
    }
  ];
}

function renderGroupNameCell(ctrl, group) {
  return m('div.flex.items-center.justify-between', [
    m('span', group.name),
    m('div.ml3.flex-none', [
      actionDropdown(groupRowActions(ctrl, group))
    ])
  ]);
}

page.oninit = function (vnode) {
  var ctrl = this;
  ctrl.BacnetDeviceModel = BacnetDeviceModel;
  ctrl.BacnetObjectModel = bacnetObjectModel;
  ctrl.newNode = prop(false);
  ctrl.scConnection = null;
  ctrl.trafficPolicy = null;
  pageRequestState.initialize(ctrl);
  pageTitle.set(null, { fallback: ctrl.BacnetDeviceModel.name });

  ctrl.init = function () {
    return pageRequestState.run(ctrl, function () {
      return ctrl.getDevice()
        .then(ctrl.getGroups);
    }, { errorMessage: 'Unable to load BACnet device data:' });
  };

  ctrl.getDevice = function () {
    return loaders.requestWithLoader({
      url: '/api/v1/bacnetdevice/' + m.route.param('id') + '?embed=pv',
      method: 'GET'
    })
    .then(function (res) {
      // Store the record and exclude Poll Groups from the objects list
      ctrl.record = res;
      pageTitle.set(ctrl.record, { fallback: ctrl.BacnetDeviceModel.name });
      if (Array.isArray(ctrl.record.children)) {
        ctrl.record.children = ctrl.record.children.filter(function (child) {
          return child['@class'] !== 'PollGroup';
        });
      }
      ctrl.sort();
      ctrl.newNode(true);
      ctrl.scConnection = null;
      loaders.requestWithLoader({
        url: '/api/v1/bacnetdevice/' + String(ctrl.record['@rid']).replace(/^#/, '') + '/traffic-policy',
        method: 'GET',
        loader: 'background'
      }).then(function (policy) {
        ctrl.trafficPolicy = policy;
      }).catch(function () {
        ctrl.trafficPolicy = null;
      });
      var gateway = bacnetPresentation.bacnetServer(ctrl.record);
      if (gateway && gateway.transport === 'bacnet-sc' && gateway.scConnection) {
        return loaders.requestWithLoader({
          url: '/api/v1/bacnetscconnection/' + String(gateway.scConnection).replace(/^#/, ''),
          method: 'GET',
          loader: 'background'
        }).then(function (connection) {
          ctrl.scConnection = connection;
        }).catch(function () {
          // The route summary can still show the connection RID when its record is unavailable.
          ctrl.scConnection = null;
        });
      }
    });
  };

  ctrl.getGroups = function () {
    return loaders.requestWithLoader({
      url: '/api/v1/bacnetdevice/' + m.route.param('id') + '/pollgroups/',
      method: 'GET'
    })
    .then(function (res) {
      ctrl.groups = res || [];
      // Sort groups by name (case-insensitive)
      ctrl.groups.sort(function (a, b) {
        var an = (a && a.name) ? a.name : '';
        var bn = (b && b.name) ? b.name : '';
        return an.localeCompare(bn, undefined, { sensitivity: 'base' });
      });
      ctrl.newNodeGroups = prop(true);
    })
    .catch(function (error) {
      // Poll groups supplement the device page. Keep the device usable when
      // that optional request is temporarily unavailable.
      console.error('Unable to load BACnet poll groups:', error);
      ctrl.groups = [];
      ctrl.newNodeGroups = prop(true);
      return [];
    });
  };

  ctrl.sort = function () {
    ctrl.record.children.sort(sortByStatus);
  };

  modal.on('closed', ctrl.init);
  
  ctrl.init();
  ctrl.childrenToShow = [];
  ctrl.groupsToShow = [];
};

page.onremove = function () {
  modal.off('closed', this.init);
};

page.view = function () {
  var ctrl = this;
  var stateView = pageRequestState.view(ctrl);
  if (stateView) return stateView;
  if(!ctrl.record) return
  var gateway = ctrl.record.breadcrumbs[0];
  var routeDetails = bacnetPresentation.deviceRouteDetails(ctrl.record, ctrl.scConnection);
  var detailFields = Object.assign({}, ctrl.BacnetDeviceModel.fields, {
    trafficHandlingOverride: Object.assign(
      {}, ctrl.BacnetDeviceModel.fields.trafficHandlingOverride, { hidden: true }
    )
  });
  if (routeDetails && routeDetails.direct) {
    detailFields.network = Object.assign({}, ctrl.BacnetDeviceModel.fields.network, { hidden: true });
    detailFields.address = Object.assign({}, ctrl.BacnetDeviceModel.fields.address, { hidden: true });
  }
  var detailModel = Object.assign({}, ctrl.BacnetDeviceModel, { fields: detailFields });
  var routeExtras = routeDetails ? {
    route: { label: 'Route', value: routeDetails.route },
    peerVmac: { label: 'Peer VMAC', value: routeDetails.peerVmac },
    connection: { label: 'Connection', value: routeDetails.connection }
  } : null;
  routeExtras = routeExtras || {};
  routeExtras.trafficOverride = {
    label: 'Traffic Handling Override',
    value: ctrl.record.trafficHandlingOverride === 'sensitive'
      ? 'Sensitive Device'
      : 'Inherit from BACnet Host'
  };
  if (ctrl.trafficPolicy && ctrl.trafficPolicy.policy) {
    var effective = ctrl.trafficPolicy.policy;
    routeExtras.trafficHandling = {
      label: 'Effective Traffic Handling',
      value: effective.profile === 'legacy'
        ? 'Existing traffic setting (compatibility) · inherited · ' + ctrl.trafficPolicy.rolloutMode
        : effective.profile.charAt(0).toUpperCase() + effective.profile.slice(1) +
          (effective.sensitiveDevice ? ' · Sensitive Device' : ' · inherited') +
          ' · ' + effective.requestSpacingMs + ' ms spacing · ' + ctrl.trafficPolicy.rolloutMode
    };
  }
  return m('div', [
    m("div.mh3.mb3.pb2.bb.bw1.b--mid-gray.near-white.flex.justify-between.items-center.display",  [
      m('div.pb2.f-subheadline.fw5', [
        m('div.dib-ns.mr2', [
          m(m.route.Link, {href: '/networks'}, 'Networks'),
          ' / '
        ]),
        ctrl.record.breadcrumbs.map(function (ancestor, idx) {
          if (ancestor['@id'] == ctrl.record['@id']) {
            return m('div.dib-ns.mr2', ctrl.record.name)
          } else {
            return m('div.dib-ns.mr2', [
              m(m.route.Link, {href: '/' + ancestor['@id'].split('/').slice(3).join('/').toLowerCase()}, ancestor.name),
              ' / '
            ])
          }
        })
      ]),
      (function () {
        if(edit.vm.editing() && auth.user().isSuperuser == 1){
          return m(rowActionDropdown, {
            items: [
              {
                label: 'Edit ' + ctrl.BacnetDeviceModel.name,
                icon: 'ion-ios-compose',
                onclick: () => ctrl.BacnetDeviceModel.editDialogue(ctrl.record)
              },
              {
                label: 'Export BACnet Device',
                icon: 'ion-document-text',
                onclick: () => networkTreeTransferModal.openHostExportModal(gateway, [ctrl.record])
              },
              {
                label: 'New Poll Group',
                icon: 'ion-plus',
                onclick: () => bacnetPollGroup.editDialogue({ parent: ctrl.record['@rid'] })
              },
              {
                label: 'New ' + ctrl.BacnetObjectModel.name,
                icon: 'ion-plus',
                onclick: () => ctrl.BacnetObjectModel.editDialogue({parent: ctrl.record['@rid']})
              }
            ]
          })
        }
      })(),
    ]),
    modelDetail(ctrl, detailModel, routeExtras),
    modelActions(ctrl, ctrl.BacnetDeviceModel),
    m('div.mh3.mv3.bw1.pv1.tc.f3.bb', equipmentClassToDisplayName(ctrl.BacnetObjectModel.name, true)),
    m('div.cf', browse(ctrl)),
    m('div.mh3.mt3.mb2.bw1.pv1.flex.items-center.justify-between.bb', [
      m('div.f3', 'Groups'),
      auth.user().isSuperuser == 1 ?
        m('div.dib',
          m(button, { label: 'Autocreate Poll Groups', class: '', func: function () { openBulkPollGroupModal(ctrl); } })
        ) : null
    ]),
    m('div.cf', groupsView(ctrl)),
  ])
};

function browse (ctrl) {
  return m('div.mh3',[
    m(paginationWithSearch, {
      data: ctrl.record.children,
      newNode: ctrl.newNode,
      dataToShow: ctrl.childrenToShow,
      placeHolder: 'Search',
      itemsPerPage: 30,
      fieldsToSearch: ['name']
    },[
      m('div.overflow-hidden',[
        m('div.dragscroll-container', [
          m('div.dragscroll', {oncreate:dragscroll}, [
            m('table.w-100.f4.mb4.pt3.mr4', [
              tableColumns.colgroup(bacnetObjectFields),
              m('thead', [
                m('tr', [ 
	                  bacnetObjectFields.map(field => {
	                    return m('th.ph0.tl', field)
	                  })
	                ])
                
              ]),
              m('tbody', [
                ctrl.childrenToShow.map(children => {
                  if(!children['@rid']){
                    return m('tr', [
	                      bacnetObjectFields.map(field => {
	                        return m('td.tl.nowrap',[
	                          m('label',{style:{'visibility':'hidden'}}, 'No Data')
	                        ])
	                      })
	                    ])
	                  }else{
	                    let url = '/' + children['@id'].split('/').slice(3,5).join('/').toLowerCase();
	                    return m('tr', [
	                      m('td.tl.nowrap', renderObjectNameCell(ctrl, children, url)),
	                      m('td.tl.nowrap', children['objectId']),
	                      m('td.tl.nowrap', getKeyByValue(bacnetEnums.ObjectType, children.objectType) || children.objectType),
	                      m('td.tl.nowrap', children['description']),
	                      m(presentValueTd, { objectRecord: children })
	                    ])
	                  }
                })
              ])
            ])
          ])
        ])
      ])
      
    ])
  ])
};

// Cell component that resolves and renders Present Value via pointTd
var presentValueTd = {
  oninit: function (vnode) {
    this.point = null;
    this.loading = false;
    if (vnode.attrs.objectRecord && vnode.attrs.objectRecord.presentValuePoint) {
      this.point = vnode.attrs.objectRecord.presentValuePoint;
    } else {
      this._load(vnode.attrs.objectRecord);
    }
  },
  onbeforeupdate: function (vnode, old) {
    if (!old || !old.attrs || !old.attrs.objectRecord || vnode.attrs.objectRecord['@rid'] !== old.attrs.objectRecord['@rid']) {
      if (vnode.attrs.objectRecord && vnode.attrs.objectRecord.presentValuePoint) {
        this.point = vnode.attrs.objectRecord.presentValuePoint;
      } else {
        this._load(vnode.attrs.objectRecord);
      }
    }
  },
  _load: function (objectRecord) {
    var ctrl = this;
    if (!objectRecord || !objectRecord['@rid']) { return; }
    ctrl.loading = true;
    // Fetch the object's properties to find PRESENT_VALUE
    loaders.requestWithLoader({
      url: '/api/v1/bacnetobject/' + String(objectRecord['@rid']).slice(1),
      method: 'GET',
      loader: 'silent'
    })
    .then(function (objRes) {
      var pvProp = (objRes.children || []).find(function (c) {
        return c.name === 'PRESENT_VALUE' || c.propertyId === bacnetEnums.PropertyIdentifier?.PRESENT_VALUE;
      });
      if (!pvProp || !pvProp['@rid']) return null;
      // Now load the PV property to get its child Point
      return loaders.requestWithLoader({
        url: '/api/v1/bacnetproperty/' + String(pvProp['@rid']).slice(1),
        method: 'GET',
        loader: 'silent'
      });
    })
    .then(function (propRes) {
      if (!propRes || !Array.isArray(propRes.children)) return;
      // Choose the point child (there should typically be one with index/value)
      var pt = propRes.children.find(function (c) { return c['@class'] === 'Point'; }) || propRes.children[0];
      this.point = pt || null;
    }.bind(this))
    .finally(function () {
      ctrl.loading = false;
      m.redraw();
    });
  },
  view: function () {
    var ctrl = this;
    if (ctrl.point && ctrl.point['@rid']) {
      return m(pointTd, {
        columnRecord: { in: ctrl.point },
        tdClass: '.nowrap bl-0',
        options: { skipEditCheck: true, keepPollingOnModalOpen: true, disableInteractions: true }
      });
    }
    return m('td.tl.nowrap', '—');
  }
};

function groupsView(ctrl) {
  if (!ctrl.groups) return m('div.mh3', '');
  return m('div.mh3',[
    m(paginationWithSearch, {
      data: ctrl.groups,
      newNode: ctrl.newNodeGroups,
      dataToShow: ctrl.groupsToShow,
      placeHolder: 'Search',
      itemsPerPage: 10,
      fieldsToSearch: ['name'],
      hideSearch: true
    },[
      m('div.overflow-hidden',[
        m('div.dragscroll-container', [
          m('div.dragscroll', {oncreate:dragscroll}, [
            m('table.w-100.f4.mb4.pt3.mr4', [
              tableColumns.colgroup(['name', 'interval']),
              m('thead', [
                m('tr', [ 
	                  m('th.ph0.tl', 'Name'),
	                  m('th.ph0.tl', 'Interval (s)')
                ])
              ]),
              m('tbody', [
                ctrl.groupsToShow.map(group => {
	                  if(!group['@rid']){
	                    return m('tr', [
	                      m('td.tl.nowrap', m('label',{style:{'visibility':'hidden'}}, 'No Data')),
	                      m('td.tl.nowrap')
	                    ])
	                  } else {
	                    return m('tr', [
	                      m('td.tl.nowrap', renderGroupNameCell(ctrl, group)),
	                      m('td.tl.nowrap', group.interval)
	                    ])
	                  }
                })
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}

function sortByStatus (a,b) {
  if (STATUSES.indexOf(a.status) < STATUSES.indexOf(b.status)) {
    return 1;
  } else if (STATUSES.indexOf(a.status) > STATUSES.indexOf(b.status)) {
    return -1;
  } else {
    return 0;
  }
};

function getKeyByValue (obj, value) {
  return Object.keys(obj).find(key => obj[key] === value);
}

module.exports = page;

// Modal: bulk create poll groups for a device
function openBulkPollGroupModal(ctrl) {
  // Local state holder component for the modal body
  var BulkForm = {
    oninit: function () {
      this.count = prop(1);
      this.interval = prop(600);
      this.loading = prop(false);
      // Expose current state for the submit handler
      BulkForm._state = this;
    },
    view: function () {
      return m('div', [
        m('div.mb3.near-white', [
          m('span', '⚠️ '),
          'Warning, this will replace all existing groups named "Poll Group X".'
        ]),
        m('div.mb3', [
          m('label.db.mb1', 'Number of Groups'),
          m('input.form-control', {
            type: 'number',
            min: 1,
            value: this.count(),
            oninput: (e) => { this.count(e.target.value); }
          })
        ]),
        m('div.mb2', [
          m('label.db.mb1', 'Polling Interval (seconds) for all groups'),
          m('input.form-control', {
            type: 'number', min: 0,
            value: this.interval(),
            oninput: (e) => { this.interval(Number(e.target.value) || 0); }
          })
        ])
      ]);
    }
  };

  function createAll() {
    var n = Math.max(1, Number(BulkForm._state && BulkForm._state.count && BulkForm._state.count()) || 1);
    var interval = Number(BulkForm._state && BulkForm._state.interval && BulkForm._state.interval()) || 0;
    BulkForm._state && BulkForm._state.loading && BulkForm._state.loading(true);
    var parentRid = ctrl.record && ctrl.record['@rid'];
    // First, load existing groups so we can reuse/update by name
    loaders.requestWithLoader({
      url: '/api/v1/bacnetdevice/' + String(parentRid).slice(1) + '/pollgroups/',
      method: 'GET',
      loader: 'silent'
    })
    .then(function (existing) {
      existing = Array.isArray(existing) ? existing : [];
      var tasks = [];
      var finalGroups = new Array(n);
      for (var i = 0; i < n; i++) {
        (function (idx) {
          var name = 'Autocreate Poll Group ' + String(idx + 1);
          var legacyName = 'Poll Group ' + String(idx + 1);
          var found = existing.find(function (g) { return g && (g.name === name || g.name === legacyName); });
          if (found) {
            // Update interval if needed, reuse the group
            if (Number(found.interval) !== interval) {
              tasks.push(
                loaders.requestWithLoader({
                  url: '/api/v1/bacnetpollgroup/' + String(found['@rid']).slice(1),
                  method: 'PUT',
                  body: { interval: interval },
                  loader: 'submit'
                }).then(function () { finalGroups[idx] = found; })
              );
            } else {
              finalGroups[idx] = found;
            }
          } else {
            tasks.push(
              loaders.requestWithLoader({
                url: '/api/v1/bacnetpollgroup/',
                method: 'POST',
                body: { parent: parentRid, name: name, interval: interval },
                loader: 'submit'
              }).then(function (g) { finalGroups[idx] = g; })
            );
          }
        })(i);
      }
      return Promise.all(tasks).then(function () { return finalGroups; });
    })
    .then(function (groups) {
      // Gather all BacnetProperty records with interval > 0 under this device
      var objs = Array.isArray(ctrl.record && ctrl.record.children) ? ctrl.record.children : [];
      var objReqs = objs
        .filter(function (c) { return c['@class'] === 'BacnetObject'; })
        .map(function (obj) {
          var rid = String(obj['@rid']).slice(1);
          return loaders.requestWithLoader({ url: '/api/v1/bacnetobject/' + rid, method: 'GET', loader: 'silent' });
        });
      return Promise.all(objReqs).then(function (objDetails) {
        var props = [];
        objDetails.forEach(function (od) {
          (od.children || []).forEach(function (p) {
            if (p['@class'] === 'BacnetProperty' && Number(p.interval) > 0) props.push(p);
          });
        });
        if (props.length === 0 || groups.length === 0) return [];
        // Round-robin assignment across groups
        var putReqs = [];
        for (var i = 0; i < props.length; i++) {
          var targetGroup = groups[i % groups.length];
          var propRid = String(props[i]['@rid']).slice(1);
          putReqs.push(
            loaders.requestWithLoader({
              url: '/api/v1/bacnetproperty/' + propRid + '/',
              method: 'PUT',
              body: { pollGroup: String(targetGroup['@rid']) },
              loader: 'submit'
            })
          );
        }
        return Promise.all(putReqs);
      });
    })
    .then(function () { return ctrl.getGroups(); })
    .finally(function () {
      BulkForm._state && BulkForm._state.loading && BulkForm._state.loading(false);
      modal.vm.close();
    });
  }

  modal.vm.title('Create Poll Groups');
  modal.vm.body = BulkForm;
  modal.vm.buttons([
    { label: 'Cancel', class: 'fl', func: modal.vm.close },
    { label: 'Create', class: 'fr btn-good', func: createAll }
  ]);
  modal.vm.open();
}

// Modal: list and manage properties assigned to a poll group
function openGroupPropertiesModal(ctrl, group) {
  var GroupProps = {
    oninit: function () {
      this.loading = true;
      this.items = [];
      var groupRid = String(group['@rid']).slice(1);
      loaders.requestWithLoader({
        url: '/api/v1/bacnetpollgroup/' + groupRid + '/properties',
        method: 'GET',
        loader: 'silent'
      })
      .then((rows) => {
        this.items = Array.isArray(rows) ? rows : [];
      })
      .finally(function () { this.loading = false; m.redraw(); }.bind(this));
    },
    _unassign: function (idx) {
      var item = this.items && this.items[idx];
      if (!item || !item.property || !item.property['@rid']) return;
      var rid = String(item.property['@rid']).slice(1);
      return loaders.requestWithLoader({
        url: '/api/v1/bacnetproperty/' + rid + '/',
        method: 'PUT',
        body: { pollGroup: null },
        loader: 'submit'
      }).then(() => {
        // remove from list
        this.items && this.items.splice(idx, 1);
      });
    },
    view: function () {
      if (this.loading) {
        return m('div.tc', [ m('img.h1', { src: '/images/loading-bars.svg' }) ]);
      }
      if (!this.items || this.items.length === 0) {
        return m('div', 'No properties assigned to this group.');
      }
      return m('div', [
        m('table.w-100.f4.mb2', [
	          m('thead', [
	            m('tr', [
	              m('th.tl.pv2', 'Object'),
	              m('th.tl.pv2', 'Property'),
	              m('th.tl.pv2', 'Interval')
	            ])
	          ]),
	          m('tbody', this.items.map((it, i) => {
	            return m('tr', [
	              m('td.tl.nowrap.pv2', it.objectName || '—'),
	              m('td.tl.nowrap.pv2', [
	                m('div.flex.items-center.justify-between', [
	                  m('span', it.property && it.property.name || '—'),
	                  m('a.red.dim.pointer.ml3.flex-none', { onclick: () => GroupProps._unassign.call(this, i) }, [
	                    m('i', { class: 'f4 mr1 ion-ios-trash' }),
	                    m('span', 'Remove')
	                  ])
	                ])
	              ]),
	              m('td.tl.nowrap.pv2', it.property && (it.property.interval || 0))
	            ]);
	          }))
	        ])
      ]);
    }
  };

  modal.vm.title('Properties in ' + (group.name || 'Poll Group'));
  modal.vm.body = GroupProps;
  modal.vm.buttons([
    { label: 'Close', class: '', func: modal.vm.close }
  ]);
  modal.vm.open({ extrawidth: true });
}
